import { useGetDossiersCapabilitiesQuery } from "services/streamingApi/caseManager.api";
import { DossierCapabilitiyIcon } from "./DossierCapabilitiyIcon";
import { DossierCapabilityName } from "types/DossierCapabilityName";

export interface DossierCapabilityColumnProps {
    dossierCapabilityNames: DossierCapabilityName[];
}

export function DossierCapabilityColumn(props: DossierCapabilityColumnProps) {
    // TODO this should come frome store
    const { data: dossierCapabilities } =
        useGetDossiersCapabilitiesQuery(undefined);

    const selectedDossierCapabilities =
        dossierCapabilities?.filter((x) =>
            props.dossierCapabilityNames.some((y) => y === x.name),
        ) || [];

    return (
        <>
            {selectedDossierCapabilities.map((x) => (
                <DossierCapabilitiyIcon
                    key={x.name}
                    dossierCapability={x}
                />
            ))}
        </>
    );
}
